module.exports = __webpack_public_path__ + "static/media/md-wallet.46660004.svg";